import {createBrowserRouter, RouteObject} from "react-router";
import {LayoutWrapper} from "./components/LayoutWrapper/LayoutWrapper.tsx";
import {FC} from "react";
import {InboxPage} from "./pages/InboxPage/InboxPage.tsx";
import {AuthPage} from "./pages/AuthPage/AuthPage.tsx";
import {CalendarPage} from "./pages/CalendarPage/CalendarPage.tsx";
import {ProcessingPage} from "./pages/ProcessingPage/ProcessingPage.tsx";
import {CompletePage} from "./pages/CompletePage/CompletePage.tsx";
import {DraftsPage} from "./pages/DraftsPage/DraftsPage.tsx";
import {SettingsPage} from "./pages/SettingsPage/SettingsPage.tsx";
import {CreatePage} from "./pages/CreatePage/CreatePage.tsx";
import {EventPage} from "./pages/EventPage/EventPage.tsx";
import {AdminPage} from "./pages/AdminPage/AdminPage.tsx";
import {ArchivePage} from "./pages/ArchivePage/ArchivePage.tsx";

const path = (path: string, Page: FC): RouteObject => ({
    path,
    element: <Page />,
})

export const router = createBrowserRouter([
    {
        element: <LayoutWrapper />,
        children: [
            path('/', InboxPage),
            path('/processing', ProcessingPage),
            path('/complete', CompletePage),
            path('/drafts', DraftsPage),
            path('/archive', ArchivePage),
            path('/calendar', CalendarPage),
            path('/settings', SettingsPage),
            path('/events/create', CreatePage),
            path('/events/:eventId', EventPage),
            path('/admin', AdminPage)
        ]
    },
    path('/auth', AuthPage)
])